(function () {
  'use strict';

  var app;
  var mode = '';
  var imageURL = '';
  var lastFrameURL = '';
  var videoURL = '';
  var referenceURL = '';
  var referenceType = 'image';
  var previewURLs = [];
  var pollTimer;

  function byID(id) {
    return document.getElementById(id);
  }

  function setStatus(message, error) {
    var status = byID('mv-status');
    status.textContent = message;
    status.classList.toggle('mv-error', !!error);
  }

  function requireLogin() {
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.requireLogin === 'function'
    ) {
      window.NetwrckTools.requireLogin();
      return;
    }
    location.href =
      '/login?next=' + encodeURIComponent(location.pathname + location.search);
  }
  function durationValue() {
    var field = byID('mv-duration');
    return (field && Number(field.value)) || 5;
  }

  function estimate() {
    var duration = durationValue();
    var credits;
    if (mode === 'text-to-video' || mode === 'image-to-video') {
      var quality =
        (byID('mv-quality') && byID('mv-quality').value) || 'balanced';
      var per5 = quality === 'preview' ? 46 : quality === 'native' ? 101 : 71;
      credits = Math.ceil((per5 * duration) / 5);
    } else if (mode === 'video-to-video') {
      credits = duration * 20;
    } else if (mode === 'pose-video') {
      var resolution =
        (byID('mv-resolution') && byID('mv-resolution').value) || '480p';
      var factor = resolution === '576p' ? 1.35 : resolution === '720p' ? 2 : 1;
      credits = Math.ceil((0.6 + 0.12 * duration) * factor * 1.2 * 100);
    } else if (mode === 'orbit-video') {
      credits = 45;
    } else {
      credits = duration * 30;
    }
    byID('mv-estimate').textContent =
      credits + ' credits · $' + (credits / 100).toFixed(2);
    byID('mv-generate').textContent =
      'Generate video · ' + credits + ' credits';
  }

  async function upload(file, prefix) {
    if (!window.getSignedURLAndUpload)
      throw new Error('Upload service is unavailable.');
    var extension = (file.name.split('.').pop() || 'bin').toLowerCase();
    var signed = await window.getSignedURLAndUpload(
      file,
      file.type,
      prefix + '-' + Date.now() + '.' + extension
    );
    var bucket = signed.bucket_name || 'netwrckstatic.netwrck.com';
    var base = /^https?:\/\//.test(bucket) ? bucket : 'https://' + bucket;
    return (
      base.replace(/\/$/, '') +
      '/' +
      String(signed.object_path || '').replace(/^\//, '')
    );
  }

  function localPreview(file, element) {
    var objectURL = URL.createObjectURL(file);
    previewURLs.push(objectURL);
    element.src = objectURL;
  }

  async function uploadImage(file) {
    if (!file) return;
    setStatus('Uploading image…', false);
    byID('mv-image-name').textContent = file.name;
    localPreview(file, byID('mv-image-preview'));
    try {
      imageURL = await upload(file, 'manifoldgen-image');
      setStatus('Image uploaded. Ready to generate.', false);
    } catch (error) {
      imageURL = '';
      setStatus(error.message || 'Image upload failed.', true);
    }
  }

  async function uploadLastFrame(file) {
    if (!file) return;
    setStatus('Uploading last frame…', false);
    byID('mv-last-name').textContent = file.name;
    localPreview(file, byID('mv-last-preview'));
    try {
      lastFrameURL = await upload(file, 'manifoldgen-last-frame');
      setStatus('Last frame uploaded. Ready to generate.', false);
    } catch (error) {
      lastFrameURL = '';
      setStatus(error.message || 'Last frame upload failed.', true);
    }
  }

  function syncLoop() {
    var loop = byID('mv-loop');
    var field = byID('mv-last-field');
    if (!loop || !field) return;
    field.style.opacity = loop.checked ? '0.45' : '1';
    field.style.pointerEvents = loop.checked ? 'none' : '';
    if (loop.checked) {
      lastFrameURL = '';
      byID('mv-last-name').textContent = 'Reuses the first frame';
    }
  }

  async function uploadVideo(file) {
    if (!file) return;
    setStatus('Uploading driving video…', false);
    byID('mv-video-name').textContent = file.name;
    localPreview(file, byID('mv-video-preview'));
    try {
      videoURL = await upload(file, 'manifoldgen-driving-video');
      setStatus('Driving video uploaded. Ready to generate.', false);
    } catch (error) {
      videoURL = '';
      setStatus(error.message || 'Video upload failed.', true);
    }
  }

  async function uploadReference(file) {
    if (!file) return;
    referenceType = file.type.indexOf('video/') === 0 ? 'video' : 'image';
    setStatus('Uploading reference…', false);
    byID('mv-reference-name').textContent = file.name;
    var preview = byID('mv-reference-preview');
    if (referenceType === 'image') localPreview(file, preview);
    else preview.removeAttribute('src');
    try {
      referenceURL = await upload(file, 'manifoldgen-reference');
      setStatus('Reference uploaded. Ready to generate.', false);
    } catch (error) {
      referenceURL = '';
      setStatus(error.message || 'Reference upload failed.', true);
    }
  }

  function resultVideoURL(result) {
    if (!result) return '';
    if (typeof result.video_url === 'string') return result.video_url;
    if (result.video && typeof result.video.url === 'string')
      return result.video.url;
    return result.result ? resultVideoURL(result.result) : '';
  }

  function showResult(url) {
    var stage = byID('mv-stage');
    var video = document.createElement('video');
    video.src = url;
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true;
    stage.replaceChildren(video);
    byID('mv-download').href = url;
    byID('mv-edit').href = '/tools/video-editor?src=' + encodeURIComponent(url);
    byID('mv-actions').classList.add('mv-on');
    byID('mv-output-status').textContent = 'Completed';
    byID('mv-generate').disabled = false;
  }

  function poll(jobID) {
    window.clearTimeout(pollTimer);
    pollTimer = window.setTimeout(async function () {
      try {
        var response = await fetch(
          '/api/fal/status/' + encodeURIComponent(jobID),
          { credentials: 'same-origin' }
        );
        var data = await response.json().catch(function () {
          return {};
        });
        if (!response.ok)
          throw new Error(data.error || 'Could not read job status.');
        if (data.status === 'completed') {
          var url = resultVideoURL(data.result || data);
          if (!url)
            throw new Error('Generation completed without a video URL.');
          showResult(url);
          setStatus('Video ready.', false);
          return;
        }
        if (data.status === 'failed')
          throw new Error(
            (data.error || 'Generation failed.') + ' Credits were refunded.'
          );
        var progress = data.progress ? ' · ' + data.progress + '%' : '';
        byID('mv-output-status').textContent = 'Rendering' + progress;
        setStatus('Rendering through ManifoldGen' + progress + '…', false);
        poll(jobID);
      } catch (error) {
        setStatus(error.message || 'Could not read generation status.', true);
        byID('mv-output-status').textContent = 'Failed';
        byID('mv-generate').disabled = false;
      }
    }, 3500);
  }

  function fieldValue(id, fallback) {
    var field = byID(id);
    return field ? field.value : fallback;
  }

  function checkedValue(id) {
    var field = byID(id);
    return field ? field.checked : false;
  }

  async function generate() {
    var promptField = byID('mv-prompt');
    var prompt = promptField ? promptField.value.trim() : '';
    if (mode === 'orbit-video') {
      prompt = (fieldValue('mv-prompt-orbit', '') || '').trim();
      if (!imageURL) {
        setStatus('Upload a photo to orbit first.', true);
        return;
      }
    } else if (!prompt) {
      setStatus('Describe the shot first.', true);
      return;
    }
    if (mode === 'image-to-video' && !imageURL) {
      setStatus('Upload a first frame first.', true);
      return;
    }
    if (mode === 'reference-to-video' && !referenceURL) {
      setStatus('Upload reference media first.', true);
      return;
    }
    if (mode === 'video-to-video' && (!imageURL || !videoURL)) {
      setStatus('Upload both a character image and driving video.', true);
      return;
    }
    if (mode === 'pose-video' && !videoURL) {
      setStatus('Upload a performance clip first.', true);
      return;
    }
    if (mode === 'pose-video' && !checkedValue('mv-h3-license')) {
      setStatus('Accept the MiniMax H3 license and use restrictions first.', true);
      return;
    }
    var looping = checkedValue('mv-loop');
    if (looping && !imageURL) {
      setStatus('Upload a first frame to loop.', true);
      return;
    }
    var button = byID('mv-generate');
    button.disabled = true;
    byID('mv-actions').classList.remove('mv-on');
    byID('mv-output-status').textContent = 'Queueing';
    setStatus('Submitting to ManifoldGen…', false);
    var seed = Number(fieldValue('mv-seed', '42'));
    var body = {
      mode: mode,
      prompt: prompt,
      seed: Number.isFinite(seed)
        ? Math.max(0, Math.min(4294967295, Math.round(seed)))
        : 42,
    };
    if (mode === 'pose-video') {
      body.accept_h3_license = checkedValue('mv-h3-license');
      body.video_url = videoURL;
      body.duration = durationValue();
      body.resolution = fieldValue('mv-resolution', '480p');
      body.control_scale = Number(fieldValue('mv-scale', '1'));
      body.negative_prompt = (fieldValue('mv-negative', '') || '').trim();
    } else if (mode === 'orbit-video') {
      body.image_url = imageURL;
      body.num_steps = Number(fieldValue('mv-steps', '28'));
    } else {
      body.image_url = imageURL;
      body.video_url = videoURL;
      body.reference_url = referenceURL;
      body.reference_type = referenceType;
      body.duration = durationValue();
      body.aspect_ratio = fieldValue('mv-aspect', '16:9');
      body.quality = fieldValue('mv-quality', 'balanced');
      body.engine = fieldValue('mv-engine', 'auto');
      body.loop = looping;
      body.last_frame = looping ? '' : lastFrameURL;
      body.include_audio = checkedValue('mv-audio');
    }
    try {
      var response = await fetch('/api/manifoldgen/video', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var data = await response.json().catch(function () {
        return {};
      });
      if (!response.ok) {
        if (response.status === 401) requireLogin();
        throw new Error(data.error || 'Generation could not be queued.');
      }
      setStatus(
        'Queued · ' + data.credits_charged + ' credits charged.',
        false
      );
      poll(data.job_id);
    } catch (error) {
      setStatus(error.message || 'Generation failed.', true);
      byID('mv-output-status').textContent = 'Ready';
      button.disabled = false;
    }
  }
  function applySourceQuery() {
    var src = new URLSearchParams(location.search).get('src');
    if (!src || !/^https:\/\//.test(src)) return;
    if (
      mode === 'image-to-video' ||
      mode === 'video-to-video' ||
      mode === 'orbit-video'
    ) {
      imageURL = src;
      byID('mv-image-preview').src = src;
      byID('mv-image-name').textContent =
        mode === 'orbit-video' ? 'Imported photo' : 'Imported image';
    } else if (mode === 'pose-video') {
      videoURL = src;
      byID('mv-video-preview').src = src;
      byID('mv-video-name').textContent = 'Imported clip';
    } else if (mode === 'reference-to-video') {
      referenceURL = src;
      referenceType = /\.(mp4|webm|mov)(\?|$)/i.test(src) ? 'video' : 'image';
      if (referenceType === 'image') byID('mv-reference-preview').src = src;
      byID('mv-reference-name').textContent = 'Imported ' + referenceType;
    }
  }

  function init() {
    app = byID('mv-app');
    if (!app) return;
    mode = app.dataset.mode;
    ['mv-duration', 'mv-quality', 'mv-resolution', 'mv-steps'].forEach(
      function (id) {
        var field = byID(id);
        if (field) field.addEventListener('change', estimate);
      }
    );
    byID('mv-generate').addEventListener('click', generate);
    if (byID('mv-image-file'))
      byID('mv-image-file').addEventListener('change', function (event) {
        uploadImage(event.target.files[0]);
      });
    if (byID('mv-last-file'))
      byID('mv-last-file').addEventListener('change', function (event) {
        uploadLastFrame(event.target.files[0]);
      });
    if (byID('mv-loop')) byID('mv-loop').addEventListener('change', syncLoop);
    if (byID('mv-video-file'))
      byID('mv-video-file').addEventListener('change', function (event) {
        uploadVideo(event.target.files[0]);
      });
    if (byID('mv-reference-file'))
      byID('mv-reference-file').addEventListener('change', function (event) {
        uploadReference(event.target.files[0]);
      });
    syncLoop();
    applySourceQuery();
    estimate();
  }

  window.addEventListener('beforeunload', function () {
    previewURLs.forEach(function (url) {
      URL.revokeObjectURL(url);
    });
  });
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init);
  else init();
})();
